"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSAccountAccessComponent = void 0;
const core_1 = require("@angular/core");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const generic_content_service_1 = require("../../services/generic.content.service");
const accountsettings_service_1 = require("../../services/accountsettings.service");
class CSAccountAccessComponent {
    constructor(genericContentService, accountDetailService) {
        this.genericContentService = genericContentService;
        this.accountDetailService = accountDetailService;
        this.users = new core_1.EventEmitter();
        this.getGenericContentAccessAccount();
    }
    ngOnChanges() {
        // Clear error message
        this.error = '';
        // Check if user details is set
        if (this.userDetails) {
            this.accountAccessName = this.userDetails.userName;
            this.roleId = this.userDetails.role.roleId;
            this.showForm = false;
            this.addOrEditUser = 'Edit User';
            this.isRoleIdChecked = true;
            this.scrollTo('account_access_permission');
            this.isEdit = false;
            this.isEditDetails = true;
        }
        else {
            this.isEditDetails = false;
            this.isRoleIdChecked = false;
        }
        if (this.removeUser) {
            this.error = '';
        }
    }
    ngOnInit() {
        this.dummyCount = 0;
        this.showForm = true;
        this.addOrEditUser = 'Add User';
        this.isRoleIdChecked = false;
        this.getRolesAndResponsibilities();
        this.getUsers();
    }
    tooltipAuthorizedUserInfo() {
        this.authorizedUserContentData = this.getGenericContentAccessAccount();
    }
    addUser(data) {
        this.loader = true;
        this.error = '';
        this.addOrEditUser = 'Add User';
        if (this.userDetails) {
            // update user detailes
            const updateRoleDetails = {
                'userName': this.userDetails.userName,
                'roleId': this.roleId,
                'newUserName': this.accountAccessName
            };
            this.accountDetailService.updateAuthorizedUser(updateRoleDetails).subscribe((accountInfo) => {
                this.loader = false;
                this.showForm = true;
                this.dummyCount++;
                this.accountAccessName = '';
                this.roleId = null;
                this.users.emit('Update' + this.dummyCount);
                // after update if Add User
                this.addOrEditUser = 'Add User';
                this.isEditDetails = false;
                this.isRoleIdChecked = false;
                this.userDetails = '';
            }, (err) => {
                this.loader = false;
                if (err.errorMessage === 'DUPLICATE_USER_FOUND_ERROR') {
                    this.error = 'You\'ve already assigned permissions to this user.';
                }
                else {
                    this.error = err.errorMessage;
                }
            });
        }
        else {
            // Add user
            const roleDetails = {
                userDetails: [{
                        'userName': data.userName,
                        'roleId': this.roleId
                    }]
            };
            this.accountDetailService.createAuthorizedUser(roleDetails).subscribe((accountInfo) => {
                this.loader = false;
                this.dummyCount++;
                this.users.emit('Add' + this.dummyCount);
                this.accountAccessName = '';
                this.roleId = null;
                this.showForm = true;
            }, (err) => {
                this.loader = false;
                this.users.emit(false);
                if (err.errorMessage === 'DUPLICATE_USER_FOUND_ERROR') {
                    this.error = 'You\'ve already assigned permissions to this user.';
                }
                else if (err.errorMessage === 'CONSUMER_MAX_USER_LIMITS') {
                    this.error = 'You\'ve reached the maximum number of people who can access your account. Please delete an existing user in order to add someone else.';
                }
                else if (err.errorMessage === 'USER_ROLE_NOT_FOUND_ERROR') {
                    this.error = 'User Not Found.';
                }
                else {
                    this.error = err.errorMessage;
                }
            });
        }
    }
    getGenericContentTooltip() {
        this.genericContentService.getGenericContent('genericContentForAuthorizedUserTooltip').subscribe((data) => {
            this.authorizedUserContentData = data.contentText;
        }, (err) => {
            this.error = err;
        });
    }
    getGenericContentAccessAccount() {
        this.loader = true;
        this.genericContentService.getGenericContent('genericContentManageConsumerUsers').subscribe((data) => {
            this.loader = false;
            this.accessAccountStaticContent = data.contentText;
        }, (err) => {
            this.loader = false;
            this.error = err;
        });
    }
    scrollTo(id) {
        const element = document.getElementById(id);
        element.scrollIntoView();
    }
    addUserOption() {
        this.addOrEditUser = 'Add User';
        this.isEditDetails = false;
        this.userDetails = '';
        this.dummyCount++;
        this.users.emit('remove' + this.dummyCount);
        if (this.showForm) {
            this.accountAccessName = '';
            this.roleId = null;
        }
    }
    onUsertypeChange(roleIdValue, isChecked) {
        this.isRoleIdChecked = isChecked;
        if (isChecked) {
            this.roleId = roleIdValue;
        }
        if (!this.isEdit) {
            this.isEdit = true;
        }
        if (this.userDetails) {
            this.isEditDetails = true;
        }
        else {
            this.isEditDetails = false;
        }
    }
    getUsers() {
        this.accountDetailService.getAccountAccessPermission().subscribe((accountInfo) => {
            this.allUsers = accountInfo;
        });
    }
    getRolesAndResponsibilities() {
        this.accountDetailService.getRolesAndResponsibilities().subscribe((accountInfo) => {
            this.rolesAndResponsibilities = accountInfo;
        });
    }
    titleCaseWord(title) {
        if (!title) {
            return title;
        }
        else {
            return title[0].toUpperCase() + title.substr(1).toLowerCase();
        }
    }
    inputValidator(event) {
        return ((event.charCode === 32) || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122));
    }
}
exports.CSAccountAccessComponent = CSAccountAccessComponent;
//# sourceMappingURL=accountaccesss.component.js.map